import PostForm from "@/components/forms/PostForm";
import { SEOComponent } from "@/components/shared";

const CreatePost = () => {
  return (
    <>
    <SEOComponent
      title="Create a Deal Post | Start Secure Business Deals on Busiconn"
      description="Create a deal post on Busiconn to start business conversations and close deals securely. Initiate service, freelance, digital, or goods-based deals that can be protected with escrow, verification, and dispute resolution."
      canonicalUrl="https://busiconn.com/create-post"
      keywords="create deal post, start business deal, escrow protected deals, online deal initiation, secure business transactions, freelance deal posting, service deal negotiation, B2B deal platform"
      ogType="website"
      structuredData={{
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "Create Deal Post",
        description:
          "Create and publish a deal post to initiate secure online business deals with escrow protection on Busiconn.",
        url: "https://busiconn.com/create-post",
        isPartOf: {
          "@type": "WebSite",
          name: "Busiconn",
          url: "https://busiconn.com",
        },
        mainEntity: {
          "@type": "CreateAction",
          name: "Create Deal Post",
          description:
            "Action to create a deal post that enables secure negotiation and escrow-protected business transactions.",
          target: {
            "@type": "EntryPoint",
            urlTemplate: "https://busiconn.com/create-post",
          },
        },
        breadcrumb: {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://busiconn.com",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Create Deal",
              item: "https://busiconn.com/create-post",
            },
          ],
        },
      }}
    />

      <div className="flex flex-1">
        <div className="common-container">
          <div className="max-w-5xl flex-start gap-3 justify-start w-full">
            <img
              src="/assets/icons/add-post.svg"
              width={36}
              height={36}
              alt="add"
            />
            <h2 className="h3-bold md:h2-bold text-left w-full">Create Post</h2>
          </div>

          <PostForm action="Create" />
        </div>
      </div>
    </>
  );
};

export default CreatePost;
